export default __webpack_public_path__ + "static/media/no-photo.57cdc2d5.svg";